import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaShieldAlt } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-titanium-900 border-t border-titanium-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/images/logo.webp"
                alt="SpinTitanium"
                className="h-8 w-auto"
                loading="lazy"
              />
              <span className="text-xl font-bold text-gradient">SpinTitanium</span>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Your trusted guide to the best UK casino offers. We review, compare, and help you find the perfect gaming experience.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/comparison" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">
                  Compare Offers
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-neon-blue transition-colors text-sm">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Responsible Gambling */}
          <div>
            <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
              <FaShieldAlt className="text-neon-blue" />
              Responsible Gaming
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              We promote responsible gambling. If you need help, please visit:
            </p>
            <div className="grid grid-cols-2 gap-3">
              <a 
                href="https://www.gambleaware.org" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="block transition-opacity hover:opacity-100 opacity-80"
              >
                <img 
                  src="/images/footer/gambleaware.webp" 
                  alt="BeGambleAware" 
                  className="h-auto w-full max-h-12 object-contain" 
                  loading="lazy" 
                />
              </a>
              <a 
                href="https://www.gamcare.org.uk" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="block transition-opacity hover:opacity-100 opacity-80"
              >
                <img 
                  src="/images/footer/gamcare.webp" 
                  alt="GamCare" 
                  className="h-auto w-full max-h-12 object-contain" 
                  loading="lazy" 
                />
              </a>
              <a 
                href="https://gamblingtherapy.org" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="block transition-opacity hover:opacity-100 opacity-80"
              >
                <img 
                  src="/images/footer/therapy.webp" 
                  alt="Gambling Therapy" 
                  className="h-auto w-full max-h-12 object-contain" 
                  loading="lazy" 
                />
              </a>
              <a 
                href="https://www.gamblingcommission.gov.uk" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="block transition-opacity hover:opacity-100 opacity-80"
              >
                <img 
                  src="/images/footer/commission.webp" 
                  alt="Gambling Commission" 
                  className="h-auto w-full max-h-12 object-contain" 
                  loading="lazy" 
                />
              </a>
            </div>
          </div>
        </div>

        {/* 18+ Disclaimer */}
        <div className="border-t border-titanium-800 pt-8 pb-6">
          <div className="bg-titanium-950 border-2 border-red-500/30 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-center gap-3 mb-2">
              <span className="text-2xl font-bold text-red-500">18+</span>
              <span className="text-white font-bold text-lg">Responsible Gambling</span>
            </div>
            <p className="text-gray-400 text-sm text-center max-w-3xl mx-auto">
              This website is intended for users who are 18 years of age or older. Gambling can be addictive. 
              Please play responsibly and only bet what you can afford to lose. If you feel you may have a gambling problem, 
              please seek help from the organizations listed above.
            </p>
          </div>
        </div>

        <div className="border-t border-titanium-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} SpinTitanium.com. All rights reserved. | 18+ Only | BeGambleAware
            </p>
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <span>Licensed & Regulated</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


